module.exports = __webpack_public_path__ + "static/media/Tim-Ford.b86b06ed.jpg";